import BetaChannelService from "./BetaChannelService";
import BetaChannelApiRouteService from "./BetaChannelApiRouteService";

class NakiHandheldPinkBetaChannelService extends BetaChannelService {
    constructor(apiClient) {
        super(apiClient, new BetaChannelApiRouteService("naki-handheld-pink-beta-channels"));
    }
}

export default NakiHandheldPinkBetaChannelService;
